import { StandardEvents } from '@shopify/events';
/* Marcel Afters, CRO-10X (25 Sep 2026): product page behaviour. Loaded by sections/product-information.liquid. */
(function () {
  'use strict';

  /* Size guide drawer: a native <dialog> (focus trap + Escape for free). Falls back to the Size & Fit page. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var open = e.target.closest('[data-ma-sg]');
    if (open) {
      var dlg = document.getElementById('ma-sg');
      if (dlg && typeof dlg.showModal === 'function') {
        e.preventDefault();
        dlg.showModal();
      }
      return;
    }
    if (e.target.closest('[data-ma-sg-close]')) {
      var d = e.target.closest('dialog');
      if (d) d.close();
      return;
    }
    if (e.target.matches && e.target.matches('dialog.ma-sg')) e.target.close();
  });

  /* Description: two lines, then Read more (only when there is more to read). */
  function armDesc(root) {
    [].forEach.call((root || document).querySelectorAll('[data-ma-desc]'), function (box) {
      if (box.dataset.maArmed) return;
      box.dataset.maArmed = '1';
      var t = box.querySelector('.ma-desc__t'), b = box.querySelector('.ma-desc__btn');
      if (!t || !b) return;
      if (t.scrollHeight - t.clientHeight > 4) b.hidden = false;
      b.addEventListener('click', function () {
        var open = !box.classList.contains('is-open');
        box.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', String(open));
        b.textContent = open ? 'Read less' : 'Read more';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { armDesc(); });
  else armDesc();
  var queued = 0;
  new MutationObserver(function () {
    if (queued) return;
    queued = requestAnimationFrame(function () { queued = 0; armDesc(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* Mobile: while the buy box is still below the fold, a bar that jumps to the size picker.
     It never adds to bag itself: the shopper chooses the size. */
  function armJump() {
    var buy = document.querySelector('.product-information .buy-buttons-block');
    if (!buy || !('IntersectionObserver' in window) || document.querySelector('.ma-jump')) return;
    var target = buy, label = 'Add to bag';
    [].forEach.call(document.querySelectorAll('.product-information fieldset'), function (f) {
      var lg = f.querySelector('legend');
      if (target === buy && lg && /size/i.test(lg.textContent)) { target = f; label = 'Select your size'; }
    });
    var bar = document.createElement('div');
    bar.className = 'ma-jump';
    bar.innerHTML = '<button type="button" class="ma-jump__b">' + label + '</button>';
    document.body.appendChild(bar);
    var mq = window.matchMedia('(max-width: 749px)');
    var below = false, off = false;
    /* 27 Sep (mobile QA): the theme's sticky Add to bag is hidden while no size is chosen, so once the
       shopper scrolled PAST the buy box without choosing there was no CTA at all. The jump bar now stays
       on whenever the buy box is off-screen in either direction and a size is still needed. */
    function needSize() { return document.body.classList.contains('ma-size-needed'); }
    function sync() {
      var need = needSize();
      bar.firstChild.textContent = need ? 'Select your size' : 'Add to bag';
      bar.classList.toggle('is-on', mq.matches && (below || (off && need)));
    }
    new IntersectionObserver(function (es) {
      var r = es[0].boundingClientRect;
      off = !es[0].isIntersecting;
      below = off && r.top > 0;
      sync();
    }).observe(buy);
    new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    if (mq.addEventListener) mq.addEventListener('change', sync);
    bar.firstChild.addEventListener('click', function () {
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var currentPicker = document.querySelector('.product-information variant-picker');
      var currentTarget = (needSize() && currentPicker && sizeSet(currentPicker)) || document.querySelector('.product-information .buy-buttons-block');
      if (!currentTarget) return;
      currentTarget.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
      var first = currentTarget.querySelector('input:checked, input, button');
      if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, still ? 0 : 450);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armJump);
  else armJump();

  /* PDP size gate (25 Sep): Shopify selects the first size on arrival. Require a deliberate size choice before checkout (fewer wrong-size exchanges). Colour may stay preselected so the gallery remains coherent. */
  var maSizeChosen = Object.create(null);
  function sizeSet(picker) {
    return [].filter.call(picker.querySelectorAll('fieldset'), function (f) {
      var l = f.querySelector('legend');
      return l && /\bsize\b/i.test(l.textContent || '');
    })[0] || null;
  }
  function sizeGate(picker) {
    if (!picker) return;
    var field = sizeSet(picker);
    if (!field) return;
    var pid = picker.getAttribute('data-product-id') || '';
    picker.dataset.maSizeArmed = '1';
    if (maSizeChosen[pid]) return;
    [].forEach.call(field.querySelectorAll('input[type="radio"]'), function (input) {
      input.checked = false;
      input.removeAttribute('checked');
      input.dataset.currentChecked = 'false';
      input.dataset.previousChecked = 'false';
    });
    field.style.removeProperty('--pill-width-current');
    field.style.removeProperty('--pill-width-previous');
    field.dataset.maSizeNeeded = '1';
    var legend = field.querySelector('legend');
    if (legend && !legend.querySelector('.ma-size-prompt')) {
      var prompt = document.createElement('span');
      prompt.className = 'ma-size-prompt';
      prompt.textContent = 'Choose a size';
      legend.appendChild(prompt);
    }
    document.body.classList.add('ma-size-needed');
    var box = picker.closest('.product-information') || document;
    var add = box.querySelector('.buy-buttons-block button[name="add"]');
    if (add) {
      add.disabled = true;
      add.setAttribute('aria-disabled', 'true');
      add.dataset.maSizeGate = '1';
      var text = [].filter.call(add.childNodes, function (n) { return n.nodeType === 3 && n.nodeValue.trim(); })[0];
      if (text) { text.nodeValue = 'Choose a size'; add._maTextNode = text; }
    }
  }
  function armSizes(root) {
    [].forEach.call((root || document).querySelectorAll('.product-information variant-picker[data-template-product-match="true"]'), sizeGate);
  }
  function startSizes() {
    armSizes();
    var pending = 0;
    new MutationObserver(function () {
      if (pending) return;
      pending = requestAnimationFrame(function () { pending = 0; armSizes(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startSizes);
  else startSizes();
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.product-information variant-picker input[type="radio"]')) return;
    var field = input.closest('fieldset'), picker = input.closest('variant-picker');
    if (!field || !picker || field !== sizeSet(picker)) return;
    var pid = picker.getAttribute('data-product-id') || '';
    maSizeChosen[pid] = true;
    field.removeAttribute('data-ma-size-needed');
    var prompt = field.querySelector('.ma-size-prompt');
    if (prompt) prompt.remove();
    document.body.classList.remove('ma-size-needed');
    var add = (picker.closest('.product-information') || document).querySelector('.buy-buttons-block button[name="add"][data-ma-size-gate]');
    if (add) {
      add.disabled = false;
      add.removeAttribute('aria-disabled');
      delete add.dataset.maSizeGate;
      if (add._maTextNode) add._maTextNode.nodeValue = 'Add to bag';
    }
  }, true);

  /* "Shown in <colour>": picks the colour the hero photo shows; any colour choice retires the hint. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ma-shown]');
    if (!b) return;
    var set = b.closest('fieldset');
    var want = b.getAttribute('data-ma-shown');
    var input = set && [].filter.call(set.querySelectorAll('input[type="radio"]'), function (i) { return i.value === want; })[0];
    b.remove();
    if (input) input.click();
  });
  document.addEventListener('change', function (e) {
    var set = e.target.closest && e.target.closest('fieldset');
    var hint = set && set.querySelector('.ma-shown');
    if (hint) hint.remove();
  });
})();

let selectionSequence = 0;
document.addEventListener(StandardEvents.productSelect, (event) => {
  if (!(event.target instanceof Element)) return;
  const picker = event.target.closest('variant-picker');
  const section = picker?.closest('.product-information');
  if (!section || picker.closest('product-card, dialog')) return;
  const sequence = ++selectionSequence;
  const media = section.querySelector('.product-information__media');
  media?.setAttribute('aria-busy', 'true');
  const color = picker.querySelector('input[data-option-name="Color"]:checked, input[data-option-name="Colour"]:checked');
  const colorLabel = color?.closest('fieldset')?.querySelector('.variant-option__swatch-value');
  if (colorLabel) colorLabel.textContent = color.value;
  event.promise.catch(() => {}).finally(() => {
    if (sequence !== selectionSequence) return;
    document.querySelector('.product-information__media')?.removeAttribute('aria-busy');
  });
});

/* 27 Sep (mobile QA): size tables. The description's table carries inch AND cm columns for every size
   (a fixed 1024px width, 544px wide even when squeezed), so on a phone it overflowed a 327px box. Show one
   unit at a time with an in/cm switch so every size fits; the choice is remembered across tables and pages. */
(function () {
  'use strict';
  var KEY = 'maSizeUnit';
  var unit = 'in';
  try { unit = localStorage.getItem(KEY) || 'in'; } catch (e) {}
  function unitOf(txt) {
    var t = (txt || '').trim().toLowerCase();
    if (t === 'inch' || t === 'inches' || t === 'in' || t === 'in.') return 'in';
    if (t === 'cm' || t === 'cms') return 'cm';
    return null;
  }
  function apply(box) {
    var map = box._maUnits;
    if (!map) return;
    map.cells.forEach(function (c) { c.el.hidden = c.u !== unit; });
    map.spans.forEach(function (el) { el.colSpan = 1; });
    if (map.unitRow) map.unitRow.hidden = true;
    [].forEach.call(box.querySelectorAll('.ma-units__b'), function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.u === unit));
    });
  }
  function arm(box) {
    if (box.dataset.maUnits) return;
    var t = box.querySelector('table');
    if (!t) return;
    var rows = [].slice.call(t.rows);
    var unitRow = null, units = [];
    rows.some(function (r) {
      var u = [].map.call(r.cells, function (c) { return unitOf(c.textContent); });
      if (u.filter(Boolean).length >= 2 && u.indexOf('in') > -1 && u.indexOf('cm') > -1) { unitRow = r; units = u; return true; }
      return false;
    });
    box.dataset.maUnits = unitRow ? '1' : '0';
    if (!unitRow) return;
    var cells = [], spans = [];
    rows.forEach(function (r) {
      if (r === unitRow) return;
      var cs = [].slice.call(r.cells);
      if (cs.some(function (c) { return c.colSpan === 2; })) {
        cs.forEach(function (c) { if (c.colSpan === 2) spans.push(c); });
        return;
      }
      cs.forEach(function (c, i) { if (units[i]) cells.push({ el: c, u: units[i] }); });
    });
    box._maUnits = { cells: cells, spans: spans, unitRow: unitRow };
    var bar = document.createElement('div');
    bar.className = 'ma-units';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Measurement units');
    bar.innerHTML = '<button type="button" class="ma-units__b" data-u="in" aria-pressed="false">in</button>' +
      '<button type="button" class="ma-units__b" data-u="cm" aria-pressed="false">cm</button>';
    box.parentNode.insertBefore(bar, box);
    bar._maBox = box;
    box.classList.add('is-units');
    apply(box);
  }
  function armAll() {
    [].forEach.call(document.querySelectorAll('.ma-size-table'), arm);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ma-units__b');
    if (!b) return;
    unit = b.dataset.u;
    try { localStorage.setItem(KEY, unit); } catch (err) {}
    [].forEach.call(document.querySelectorAll('.ma-size-table.is-units'), apply);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armAll);
  else armAll();
})();
